import { createStore, applyMiddleware } from 'redux';
import rootReducer from '../reducers/index';
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

const middlewares = [thunkMiddleware];

/* Use in dev mode for easier debugging */
// const logger = createLogger();
// if (process.env.NODE_ENV !== 'production') {
//   middlewares.push(logger);
// }

export default function configureStore() {
  return createStore(
    rootReducer,
    composeWithDevTools(applyMiddleware(...middlewares))
  );
}



// WEBPACK FOOTER //
// ./src/stores/configureStore.js